export const SIGNIN = "SIGNIN";
export const SIGNOUT = "SIGNOUT";
